<template>
    <div class="cz2__number-selector">
        <!-- Decrease -->
        <!-- <button
            class="cz2__number-selector__button"
            :title="$t('SELECTOR_DECREASE')"
            :disabled="value <= min"
            @click="$emit('decrease')"
        >
            <span class="cz3__selector-bar" />
        </button> -->

        <!-- Display -->
        <multiselect
            class="cz2__number-selector__select"
            v-model="selectedValue"
            :options="options"
            :searchable="searchable"
            :show-labels="false"
            :allowEmpty="false"
            placeholder=""
        >
            <template slot="singleLabel" slot-scope="props">
                <span v-if="prefix">{{prefix}} {{props.option}}</span>
                <span v-else>{{props.option}}</span>
            </template>
            <span slot="noResult"></span>
        </multiselect>

        <!-- Increase -->
        <!-- <button
            class="cz2__number-selector__button"
            :title="$t('SELECTOR_INCREASE')"
            :disabled="value >= max"
            @click="$emit('increase')"
        >
            <span class="cz3__selector-bar" />
            <span class="cz3__selector-bar cz3__selector-bar--vertical" />
        </button> -->
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    // Vars
    $selectorHeight: 44px;
    $selectorBarWidth: 10px;
    $selectorBarHeight: 3px;

    $input-border: 1px solid #979797;

    #cz2.cz2 {
        .cz2__number-selector {
            display: flex;
            height: $selectorHeight;
        }

        .cz2__number-selector__button,
        .cz2__number-selector__display {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .cz2__number-selector__button {
            width: $selectorHeight;
            position: relative;

            &:disabled {
                background: #f8f8f8;
                .cz3__selector-bar {
                    background: #999;
                }
            }
        }

        .cz2__number-selector__display {
            flex-grow: 1;
            min-width: 132px;
            border: $input-border;
            border-radius: 2px;
            padding: 13px;
            justify-content: space-between;
            position: relative;
        }

        .cz2__type__number-selector__icon {
            display: block;
            width: 13px;
            height: 8px;
            background: transparent url(../assets/arrow-small-down@2x.png) no-repeat center/contain;
        }

        .cz2__number-selector__select {
            width: 130px;
        }

        .cz3__selector-bar {
            display: block;
            width: $selectorBarWidth;
            height: $selectorBarHeight;
            background: #000;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .cz3__selector-bar--vertical {
            width: $selectorBarHeight;
            height: $selectorBarWidth;
        }
    }
</style>

<script>

    export default {
        components: {},
        props: {
            value: {
                type: Number,
                default: 1,
            },
            min: {
                type: Number,
                default: 1,
            },
            max: {
                type: Number,
                default: 1,
            },
            prefix: {
                type: String,
                default: null,
            },
            searchable: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                focusLockDisabled: true,

                selectedValue: this.value,
            };
        },
        computed: {
            options() {
                const options = [];

                for (let i = this.min; i <= this.max; i += 1) {
                    options.push(i);
                }

                return options;
            },
        },
        watch: {
            value() {
                this.selectedValue = this.value;
            },

            selectedValue() {
                this.$emit('select', this.selectedValue);
            },
        },
        methods: {},
    };
</script>
